export default __webpack_public_path__ + "static/media/ProposalLightActive.23aa7f25.svg";